define('charts/distance-overlay',["require", "exports", "../places/places", "../tracks/track-enabled", "../tracks/track-state", "../util/convert"], function (require, exports, places_1, trackEnabled, trackState, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    var overlay;
    var summaryText = "";
    var focused = false;
    function init() {
        overlay = document.getElementById("distance-overlay");
        // Subscribe to focus updates
        trackState.focusUpdates.subscribe(onFocus);
        trackEnabled.trackEnabled.subscribe(updateSummary);
    }
    exports.init = init;
    function onFocus(point, track) {
        if (point && track) {
            focused = true;
            overlay.style.display = "block";
            overlay.innerHTML = ("\n    <dl class=\"dl-horizontal\">\n      <dt>Time</dt><dd>" + timeString(point, track) + "</dd>\n      <dt>Distance</dt><dd>" + convert_1.default.distance.localString(point.x / convert_1.default.distance.units) + "</dd>\n      <dt>Altitude</dt><dd>" + convert_1.default.distance.localString(point.y / convert_1.default.distance.units) + "</dd>\n    </dl>\n    ").trim();
        }
        else {
            focused = false;
            overlay.innerHTML = summaryText;
            if (!summaryText) {
                overlay.style.display = "none";
            }
        }
    }
    function updateSummary(track) {
        if (!(0, places_1.isBASE)(track.place)) {
            return;
        }
        summaryText = "";
        if (track.stats.first11_y) {
            summaryText += "\n      <dt title=\"Altitude to 1:1 glide\" class=\"hover-title\">First 1:1</dt>\n      <dd class=\"legend-item legend-first11\">" + convert_1.default.distance.localString(track.stats.first11_y) + "</dd>";
        }
        if (track.stats.cross11) {
            summaryText += "\n      <dt title=\"Distance to cross 1:1 line\" class=\"hover-title\">Cross 1:1</dt>\n      <dd class=\"legend-item legend-cross11\">" + convert_1.default.distance.localString(track.stats.cross11) + "</dd>";
        }
        if (track.stats.feather) {
            summaryText += "\n      <dt title=\"Fly as far as possible in 200 meters altitude\" class=\"hover-title\">Feather</dt>\n      <dd class=\"legend-item legend-feather\">" + convert_1.default.distance.localString(track.stats.feather) + "</dd>";
        }
        if (summaryText) {
            summaryText = "<dl class=\"dl-horizontal\">" + summaryText + "</dl>";
            overlay.innerHTML = summaryText;
            overlay.style.display = "block";
        }
        else {
            overlay.style.display = "none";
        }
    }
    function timeString(point, track) {
        if (!point.date) {
            return "";
        }
        else if (point.millis < 10000000) {
            return (point.millis * 0.001).toFixed(1) + " s";
        }
        else {
            return ((point.millis - track.startTime()) * 0.001).toFixed(1) + " s";
        }
    }
});
//# sourceMappingURL=/assets/javascripts/charts/distance-overlay.js.map;
